// eslint-disable-next-line import/prefer-default-export
export { default as LandingPage } from './landing-page';
